<template>
  <div id="page-user-list">
    <div id="contextMenu" class="context-menu" style="display:none; position:absolute; z-index:1000;">
      <ul>
        <li @click="filterByValue">Filter By {{ currentValue }}</li>
        <li @click="filterClear">Clear</li>
      </ul>
    </div>
    <div class="flex flex-wrap-reverse items-center data-list-btn-container" v-if="!readOnlyRole">
      <div
        class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
        @click="$router.push('/outlay-add-simple')">
        <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
        <span class="ml-2 text-base text-primary">Add Queue</span>
      </div>
    </div>

    <div class="vx-card p-6 mb-8">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{
                operationsData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize :
                operationsData.length }} of {{ operationsData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery"
          @input="updateSearchQuery" placeholder="Search..." />
        <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button>
        <vs-button class="ml-4 mb-4 md:mb-0" color="danger" @click="filterFalse">Verification Required</vs-button>


      </div>
      <!-- AgGrid Table -->
      <ag-grid-vue ref="agGridTable" :components="components" :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table" :columnDefs="columnDefs" :defaultColDef="defaultColDef"
        :rowData="operationsData" rowSelection="multiple" colResizeDefault="shift" :animateRows="true"
        @cell-context-menu="onCellContextMenu" :floatingFilter="true" :pagination="true"
        :paginationPageSize="paginationPageSize" :suppressPaginationPanel="true" :enableRtl="$vs.rtl">
      </ag-grid-vue>

      <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />

    </div>

    <div class="vx-row" id="page-user-view" v-if="fileList.length > 2">
      <div class="vx-col lg:w-4/4 w-full">
        <vx-card title="IA INPUT" class="mb-base">
          <vs-table :data="fileList" class="table-dark-inverted" :max-items="1000">
            <template slot="thead">
              <vs-th>Filename</vs-th>
              <vs-th>Date upload</vs-th>
              <vs-th>Status</vs-th>
              <vs-th>Action</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td v-if="tr.name != '.ftpquota' && tr.name != 'done'"><a :href="getPreviewFile(tr.name)"
                    target="_blank">{{ tr.name }}</a></vs-td>
                <vs-td v-if="tr.name != '.ftpquota' && tr.name != 'done'">{{ formatDateTime(tr.rawModifiedAt) }}</vs-td>
                <vs-td v-if="tr.name != '.ftpquota' && tr.name != 'done' && tr.status">{{ tr.status }}</vs-td>
                <vs-td
                  v-else-if="tr.name != '.ftpquota' && tr.name != 'done' && !tr.name.endsWith('.pdf') && !tr.name.endsWith('.jpg') && !tr.name.endsWith('.png') && !tr.name.endsWith('.jpeg')"><vs-chip
                    color="orange">NOT READABLE</vs-chip></vs-td>
                <vs-td
                  v-else-if="tr.name != '.ftpquota' && tr.name != 'done' && (tr.name.endsWith('.PNG') || tr.name.endsWith('.JPG'))"><vs-chip
                    color="red">FAILED</vs-chip></vs-td>
                <vs-td v-else-if="tr.name != '.ftpquota' && tr.name != 'done'">
                  <vs-chip color="green">IN QUEUE... </vs-chip>
                </vs-td>
                <vs-td v-if="tr.name != '.ftpquota' && tr.name != 'done' && !readOnlyRole"><feather-icon v-on:click="deleteFile(tr.name)"
                    icon="TrashIcon" svgClasses="h-4 w-4" /></vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'

// Store Module
import moduleOperationList from '@/store/operation/moduleOperationList.js'
import { isAccountantOnly } from '@/helpers/roleAccess.js'

// Cell Renderer
import CellRendererLink from './cell-renderer/CellRendererLink.vue'
import CellRendererStatus from './cell-renderer/CellRendererStatus.vue'
import CellRendererVerified from './cell-renderer/CellRendererVerified.vue'
import CellRendererActions from './cell-renderer/CellRendererActions.vue'
import moment from 'moment'

export default {
  components: {
    AgGridVue,
    vSelect,
    // Cell Renderer
    CellRendererLink,
    CellRendererStatus,
    CellRendererVerified,
    CellRendererActions
  },
  data() {
    return {
      // Comptable : liste en lecture (pas d'ajout ni de suppression de fichier).
      readOnlyRole: isAccountantOnly(),
      fileList: [],
      currentValue: null,
      searchQuery: '',
      fileNameToDelete: '',
      // AgGrid
      gridApi: null,
      gridOptions: {},
      suppressSizeToFit: true,
      defaultColDef: {
        sortable: false,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: 'ID',
          valueGetter: function (params) {
            return '#' + params.data.id
          },
          filter: true,
          width: 100,
          cellRendererFramework: 'CellRendererLink'
        },
        {
          headerName: 'DATE',
          valueGetter: (params) => this.formatDate(params.data.creation),
          filter: true,
          width: 160
        },
        {
          headerName: 'SELLER',
          field: 'client',
          filter: true,
          width: 550
        },
        {
          headerName: 'EXCL. TAX',
          valueGetter: function (params) {
            if (params.data.total_htva) return Math.abs(params.data.total_htva).toFixed(2) + " " + params.data.currency
            else return "N/A"
          },
          filter: true,
          width: 250
        },
        {
          headerName: 'ENCODING',
          field: 'isexpvalid',
          filter: true,
          width: 150,
          cellRendererFramework: 'CellRendererStatus'
        },
        {
          headerName: 'AI INPUT',
          //valueGetter: (params) => this.formatD ateTime(params.data.datecreation),

          valueGetter: (params) => {
            const now = moment();
            const dateCreation = moment(params.data.datecreation);
            const diffInMinutes = now.diff(dateCreation, 'minutes');
            if (diffInMinutes < 60) {
              return `${diffInMinutes} min ago`;
            } else if (diffInMinutes < 1440) { // Moins de 24 heures
              return `${Math.floor(diffInMinutes / 60)} h ago`;
            } else {
              return `${Math.floor(diffInMinutes / 1440)} days ago`;
            }
          },
          filter: true,
          width: 150,
          cellRendererFramework: 'CellRendererStatus'
        },
        /*{
          headerName: 'IS PAID',
          field: 'isexppaid',
          filter: true,
          width: 150,
          cellRendererFramework: 'CellRendererStatus'
        },*/
        {
          headerName: 'Actions',
          field: 'transactions',
          width: 120,
          cellRendererFramework: 'CellRendererActions'
        }
      ],

      // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererStatus,
        CellRendererVerified,
        CellRendererActions
      }
    }
  },
  computed: {
    operationsData() {
      return this.$store.state.operationList.expenses
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    }
  },
  methods: {
    filterFalse() {
      var filterModel = {
        isexpvalid: { // Assurez-vous que cela correspond à l'identifiant de la colonne (colId) si différent du nom du champ (field)
          type: 'contains', // Type de condition (equals, notEqual, contains, etc.)
          filter: 'false', // La valeur que vous souhaitez appliquer au filtre
        }
      };
      this.gridOptions.api.setFilterModel(filterModel); // Appliquez le modèle de filtre à la grille
    },
    filterClear() {
      var filterModel = {
        client: { // Assurez-vous que cela correspond à l'identifiant de la colonne (colId) si différent du nom du champ (field)
          type: 'contains', // Type de condition (equals, notEqual, contains, etc.)
          filter: '', // La valeur que vous souhaitez appliquer au filtre
        },
        isexpvalid: { // Assurez-vous que cela correspond à l'identifiant de la colonne (colId) si différent du nom du champ (field)
          type: 'contains', // Type de condition (equals, notEqual, contains, etc.)
          filter: '', // La valeur que vous souhaitez appliquer au filtre
        }
      };
      this.gridOptions.api.setFilterModel(filterModel); // Appliquez le modèle de filtre à la grille
      this.hideContextMenu();
    },
    copyValue() {
      console.log('Copying value:', this.currentValue);
      navigator.clipboard.writeText(this.currentValue).then(() => {
        console.log('Value copied to clipboard');
      }, (err) => {
        console.error('Error copying text: ', err);
      });
      this.hideContextMenu();
    },
    hideContextMenu() {
      const contextMenu = document.getElementById('contextMenu');
      contextMenu.style.display = 'none';
    },
    filterByValue() {
      var filterModel = {
        client: { // Assurez-vous que cela correspond à l'identifiant de la colonne (colId) si différent du nom du champ (field)
          type: 'contains', // Type de condition (equals, notEqual, contains, etc.)
          filter: this.currentValue, // La valeur que vous souhaitez appliquer au filtre
        }
      };
      this.gridOptions.api.setFilterModel(filterModel); // Appliquez le modèle de filtre à la grill
      this.hideContextMenu();
    },
    onCellContextMenu(event) {
      this.currentValue = event.value; // Stocker la valeur actuelle pour les actions

      if (event.column.colId === 'client') {
        const contextMenu = document.getElementById('contextMenu');
        let posX = event.event.clientX;
        const posY = event.event.clientY;

        contextMenu.style.display = 'block';
        contextMenu.style.left = `${posX - 265}px`;
        contextMenu.style.top = `${posY}px`;
      }
      // un peu décal a cause du menu de gauche.
    },
    format_dates(value, withhour) {
      if (value) {
        if (withhour)
          return moment(String(value)).format("DD MMM YYYY HH:mm:ss");
        else return moment(String(value)).format("DD MMM YYYY");
      }
    },
    async loadFileList() {
      try {
        const response = await axios.get('https://xylo.codesinn.com/api/ftp/files');
        this.fileList = response.data.sort((a, b) => {
          // Convertir les dates en timestamps et trier
          return new Date(b.rawModifiedAt) - new Date(a.rawModifiedAt);
        });
      } catch (error) {
        console.error("Erreur lors de la récupération des fichiers : ", error);
      }
    },
    showFileDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: "File Deleted",
        text: "The File was successfully deleted"
      });
    },
    showFileDeleteAlerts() {
      this.$vs.notify({
        color: "danger",
        title: "File Not Deleted",
        text: "The File was successfully deleted"
      });
    },
    async deleteFileOne() {
      try {
        await axios.post('https://xylo.codesinn.com/api/outlay/deletefile', { fileName: this.fileNameToDelete }, {
          headers: {
            'Content-Type': 'application/json'
          }
        }).then((response) => {
          this.loadFileList()
          this.showFileDeleteSuccess();
        });
      } catch (error) {
        console.error('Error while deleting file:', error);
        this.showFileDeleteAlerts()
      }
    },
    deleteFile(name) {
      this.fileNameToDelete = name;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm Delete",
        text: `You are about to delete the file ${name}`,
        accept: this.deleteFileOne,
        acceptText: "Delete File"
      });
    },
    getPreviewFile(name) {
      return "https://xylo.codesinn.com/ftp/" + name
    },
    ManualInput(name) {
      this.$vs.notify({
        title: "Denied",
        text: "Access to the this page is reserved for administrators",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger",
        position: "bottom-right",
        time: 8000,
      });
    },
    formatDateTime(rawDateTime) {
      const date = new Date(rawDateTime);
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-indexed
      const year = date.getFullYear();
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const seconds = date.getSeconds().toString().padStart(2, '0');

      return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    },
    formatDate(dateString) {
      let date = new Date(dateString);
      let day = date.getDate().toString().padStart(2, '0');
      let month = (date.getMonth() + 1).toString().padStart(2, '0'); // Les mois sont indexés à partir de 0
      let year = date.getFullYear();
      return `${day}/${month}/${year}`;
    },
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if (val !== 'all') {
        modelObj = { type: 'equals', filter: val }
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()

      // Reset Filter Options
      this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = { label: 'All', value: 'all' }

      this.$refs.filterCard.removeRefreshAnimation()
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val)
    }
  },
  mounted() {
    this.$nextTick(() => {
      const gridEl = this.$refs.agGridTable.$el; // Assurez-vous que cela pointe vers l'élément correct
      gridEl.addEventListener('contextmenu', (event) => {
        event.preventDefault();
        //alert('Menu contextuel empêché');
      });
    });
    this.gridApi = this.gridOptions.api

  },
  async created() {
    this.$vs.loading()
    if (localStorage.getItem("login-roles").toLowerCase().includes("user")) {
      this.$vs.notify({
        title: "Denied",
        text: "Access to the this page is reserved for administrators",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger",
        position: "bottom-right",
        time: 8000,
      });
      this.$router.push({ path: "/dashboard/analytics" });
    }
    if (!moduleOperationList.isRegistered) {
      this.$store.registerModule('operationList', moduleOperationList)
      moduleOperationList.isRegistered = true
    }
    this.$store.dispatch('operationList/fetchExpenses')
      .then(response => {
        this.$vs.loading.close()
      })
      .catch(err => { console.error(err) })
    this.loadFileList()
  }
}

</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}


.context-menu {
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.context-menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.context-menu ul li {
  padding: 10px;
  cursor: pointer;
}

.context-menu ul li:hover {
  background-color: #f0f0f0;
}
</style>
